import { render, staticRenderFns } from "./Teamladder.vue?vue&type=template&id=4f182288&"
import script from "./Teamladder.vue?vue&type=script&lang=js&"
export * from "./Teamladder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports